import { render, staticRenderFns } from "./ExpandableItemTimbresIlimitados.vue?vue&type=template&id=49992ca1&scoped=true&"
import script from "./ExpandableItemTimbresIlimitados.vue?vue&type=script&lang=js&"
export * from "./ExpandableItemTimbresIlimitados.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItemTimbresIlimitados.vue?vue&type=style&index=0&id=49992ca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49992ca1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
